/** react-query хуки «Аналитики ОПТ». retry выключен: 503 «витрина не собрана» и 422 ретраями не
 *  лечатся — ошибка видна сразу. */
import { useQuery } from "@tanstack/react-query";

import {
  getWholesaleLines,
  getWholesaleMeta,
  getWholesaleNode,
  getWholesaleProducts,
  getWholesaleSummary,
  type LinesQuery,
  type NodeQuery,
  type ProductsFilter,
} from "@/api/wholesale";
import type { MonthRange } from "./calc";

const STALE = 5 * 60 * 1000;
const ROOT = "wholesale";

export function useWholesaleMeta() {
  return useQuery({
    queryKey: [ROOT, "meta"],
    queryFn: ({ signal }) => getWholesaleMeta(signal),
    staleTime: STALE,
    retry: false,
  });
}

export function useWholesaleSummary(r: MonthRange | null, cmp: MonthRange | null) {
  return useQuery({
    queryKey: [ROOT, "summary", r?.from, r?.to, cmp?.from ?? null, cmp?.to ?? null],
    queryFn: ({ signal }) => getWholesaleSummary(r!.from, r!.to, cmp, signal),
    staleTime: STALE,
    retry: false,
    enabled: r !== null,
  });
}

/** `portfolio` — область экрана (отгрузки и к отгрузке периода + все просроченные). */
export function useWholesaleProducts(
  r: MonthRange | null,
  filter: ProductsFilter,
  portfolio: boolean,
  enabled: boolean,
) {
  return useQuery({
    queryKey: [ROOT, "products", r?.from, r?.to, filter, portfolio],
    queryFn: ({ signal }) => getWholesaleProducts(r!.from, r!.to, filter, portfolio, signal),
    staleTime: STALE,
    retry: false,
    enabled: r !== null && enabled,
  });
}

export function useWholesaleLines(q: LinesQuery | null) {
  return useQuery({
    queryKey: [ROOT, "lines", q],
    queryFn: ({ signal }) => getWholesaleLines(q!, signal),
    staleTime: STALE,
    retry: false,
    enabled: q !== null,
  });
}

/** Узел для карточки сущности (покупатель / товар / заказ / узел дерева). */
export function useWholesaleNode(q: NodeQuery | null) {
  return useQuery({
    queryKey: [ROOT, "node", q],
    queryFn: ({ signal }) => getWholesaleNode(q!, signal),
    staleTime: STALE,
    retry: false,
    enabled: q !== null,
  });
}
